import get from 'lodash/get';

import { getOnboardingHostname } from './getOnboardingHostname';

const hostname = getOnboardingHostname();

const clientIdByHostname: Record<string, string> = {
  'auth.dev-myaccount-login.revers.io': 'dev-revers.io',
  'auth.dev-project-login.revers.io': 'dev-project.revers.io',
  'auth.dev-auchan-login.revers.io': 'dev-auchan.revers.io',
  'auth.sav-login.dev.auchan.fr': 'dev-auchan.revers.io',
};

const authorityByHostname: Record<string, string> = {
  'auth.dev-auchan-login.revers.io': 'https://dev-auchan-login.revers.io',
  'auth.sav-login.dev.auchan.fr': 'https://sav-login.dev.auchan.fr',
};

const authorityByClientId: Record<string, string> = {
  'dev-revers.io': 'https://dev-myaccount-login.revers.io',
  'dev-project.revers.io': 'https://dev-project-login.revers.io',
  'dev-auchan.revers.io': 'https://sav-login.dev.auchan.fr',
  'reversio.dev.revers.io': 'https://reversio-login.dev.revers.io',
};

const defaultClientId = 'dev-revers.io';

function computeAuthority({ clientId }: { clientId: string }) {
  const defaultAuthority = get(authorityByClientId, clientId);
  const defaultAuthorityFromHostname = get(authorityByHostname, hostname);

  if (hostname.includes('.dev-authenticator.pages.dev')) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.authority = 'https://dev-myaccount-login.revers.io';

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return this;
  }

  if (hostname !== 'localhost' && defaultAuthorityFromHostname) {
    return defaultAuthorityFromHostname;
  }

  if (defaultAuthority) {
    return defaultAuthority;
  }

  const builtAuthorityFromClientId = clientId.replace(
    '.revers.io',
    '-login.revers.io',
  );

  return builtAuthorityFromClientId.includes('https://')
    ? builtAuthorityFromClientId
    : `https://${builtAuthorityFromClientId}`;
}

function setAuthority(authority?: string) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { clientId } = this;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  this.authority = authority || computeAuthority({ clientId });

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return this;
}

function computeClientId() {
  if (import.meta.env.VITE_CLIENTID) {
    return import.meta.env.VITE_CLIENTID;
  }

  if (
    hostname === 'localhost' ||
    hostname.includes('.dev-authenticator.pages.dev')
  ) {
    return defaultClientId;
  }

  if (clientIdByHostname[hostname]) {
    return clientIdByHostname[hostname];
  }

  if (hostname.includes('.auth.dev.revers.io')) {
    return hostname.replace('.auth.dev.revers.io', '.selfcare.dev.revers.io');
  }

  if (hostname.includes('-auth')) {
    return hostname.replace('-auth', '');
  }

  if (hostname.includes('auth.')) {
    return hostname.replace('-login', '').replace('auth.', '');
  }

  return hostname;
}

const clientId = computeClientId();

const AuthConfiguration = {
  clientId,
  authority: computeAuthority({ clientId }),
  scope: 'openid email api',
  setAuthority,
};

export default AuthConfiguration;
